export const environment = {
  production: true,
  buildId: '4205543931225121',
  configFile: 'config.json',
};
